import { Box, DatePicker, Flex } from 'ui'
import { DateRange } from 'react-day-picker'
import { track } from 'lib/amplitude'
import { useVndlyTimesheetContext } from '../context/VndlyTimesheetProvider'
import { CompaniesSelector } from './CompaniesSelector'

export const FilterBar = () => {
  const {
    state: { filters },
    actions: { setFilters },
  } = useVndlyTimesheetContext()

  return (
    <Flex mt={[0, 2]} mb={[3, 4]} flexWrap={'wrap'}>
      <Box width={[1, 1 / 2, 1 / 2, 1 / 2]} pr={[0, 2]} mb={[2, 2]}>
        <CompaniesSelector />
      </Box>
      <Box width={[1, 1 / 2, 1 / 2, 1 / 2]} pr={[0, 0]} mb={[2, 0]}>
        <DatePicker
          mode={'range'}
          selected={{ from: filters.dateFrom, to: filters.dateTo } as DateRange}
          placeholder={'Pick Date Range'}
          onSelect={(newDates) => {
            if (newDates) {
              const typedDates = newDates as DateRange
              if (typedDates.from && typedDates.to) {
                track('button_click, vndly_timesheet_filter_date_range', {
                  dateFrom: typedDates.from,
                  dateTo: typedDates.to,
                })
                setFilters({
                  ...filters,
                  dateFrom: typedDates.from,
                  dateTo: typedDates.to,
                })
              }
            }
          }}
        />
      </Box>
    </Flex>
  )
}
